import { z } from "zod";

/**
 * `POST /reports/signals/monthly` — what the trackers found each month, and what came
 * of it. Rates are nullable: no denominator yet renders as "—", never as 0%.
 */
export const SignalMonthRowSchema = z.object({
	/** `YYYY-MM` */
	monthKey: z.string(),
	trackedProfiles: z.coerce.number(),
	trackedCompanies: z.coerce.number(),
	newSignals: z.coerce.number(),
	signalCompanies: z.coerce.number(),
	leadsContacted: z.coerce.number(),
	leadsEnded: z.coerce.number(),
	repliedLeads: z.coerce.number(),
	positiveReplies: z.coerce.number(),
	replyRate: z.coerce.number().nullable(),
	sentimentRatio: z.coerce.number().nullable(),
});

export type SignalMonthRow = z.infer<typeof SignalMonthRowSchema>;

/**
 * What the numbers could possibly cover. Signals only exist for tracked lists, so an
 * all-zero report on an untracked list means "not tracked", not "no signals".
 */
export const SignalScopeSchema = z.object({
	requestedListIds: z.array(z.number()),
	trackedListIds: z.array(z.number()),
	companyHasTrackers: z.boolean(),
});

export type SignalScope = z.infer<typeof SignalScopeSchema>;

export const SignalAnalyticsSchema = z.object({
	months: z.array(SignalMonthRowSchema),
	scope: SignalScopeSchema,
});

export type SignalAnalytics = z.infer<typeof SignalAnalyticsSchema>;
